/**
 * design_handoff_accept_invitation §4 — screen 7 (Declined). Stays put and
 * offers a link instead of the old 5-second hard redirect to the homepage.
 *
 * @param {string} organizationName
 * @param {string=} inviterName
 */
import React from "react";
import AuthStateCard from "../AuthPages/AuthStateCard";
import { Button } from "../../theme/untitled";
import appConfig from "../../../../appConfig";

const DeclinedScreen = ({ organizationName, inviterName }) => (
  <AuthStateCard
    tone="neutral"
    icon="Check"
    title="Invitation declined"
    actions={
      <Button
        hierarchy="secondaryGray"
        onClick={() => {
          window.location.href = appConfig.homepage;
        }}
      >
        Go to revisual.io
      </Button>
    }
  >
    <p>
      You won't be added to {organizationName}.
      {inviterName ? ` We've let ${inviterName} know.` : ""} There's nothing
      else to do, so you can close this tab.
    </p>
  </AuthStateCard>
);

export default DeclinedScreen;
